import React from "react";
import './Box2.css';

function Box2(probs) {

  return (
    <div className="box2-box3">
      <div className="box2-box6"><img className="box2-box6-picture8" src={probs.ImgBox2} alt="picture8"/></div>
      <div className="box2-box7">{probs.NadpisBox2}</div>
    </div>
  );
}

export default Box2;
